import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { paymentActions } from "../slices/payment";
import { getErrorMessage } from "../../utils/errorUtils";
import { PaymentQueryParams } from "../../shared/dtos/payment/PaymentQueryParams";
import { PaymentSummaryDto } from "../../shared/dtos/payment/PaymentSummaryDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getPayments =
  (params?: PaymentQueryParams) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(paymentActions.setLoading());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<PaymentSummaryDto>>
      >("/payments", {
        headers: { requiresAuth: true },
        params,
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(paymentActions.setItems(data.data.content));
        dispatch(paymentActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(paymentActions.setError(getErrorMessage(error)));
    }
  };
